import { jsx as _jsx } from "react/jsx-runtime";
function initialsOf(name) {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const first = parts[0];
    if (!first)
        return '?';
    const last = parts[parts.length - 1];
    if (parts.length === 1 || !last)
        return first.slice(0, 2).toUpperCase();
    return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
}
export function Avatar({ name, src, size = 32 }) {
    const style = { width: size, height: size, fontSize: Math.round(size * 0.38) };
    if (src) {
        return _jsx("img", { className: "assist-avatar", style: style, src: src, alt: "", "aria-hidden": "true" });
    }
    return (_jsx("span", { className: "assist-avatar assist-avatar--initials", style: style, "aria-hidden": "true", children: initialsOf(name) }));
}
//# sourceMappingURL=Avatar.js.map